(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDialogController', TabFilesDialogController);

    TabFilesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabFiles', 'DataUtils', 'TabFileTypes', '$state', '$window'];

    function TabFilesDialogController($timeout, $scope, $stateParams, $q, entity, TabFiles, DataUtils, TabFileTypes, $state, $window) {
        var vm = this;

        // vm.tabFiles = entity;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabFiles = entity;
                if(vm.tabFiles.id !== null){
                    getPermsFromString(vm.tabFiles.perms);
                }
            });
        }
        vm.tabfiletypes = TabFileTypes.query({size: 1000});
        vm.showInlineEditor = false;
        vm.isCustomPermission = false;
        vm.permissions = {};

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFilesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-files');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

            var permsString = getPerms();
            if (permsString === "---------" || permsString === "")
                permsString = null;

            vm.tabFiles.permissions = vm.permissions.permission;
            vm.tabFiles.categories = vm.permissions.category;
            vm.tabFiles.perms = permsString;
            if(vm.tabFiles.isActive == null){
                vm.tabFiles.isActive = false;
            }

            if (vm.tabFiles.id !== null) {
                TabFiles.update(vm.tabFiles, onSaveSuccess, onSaveError);
            } else {
                TabFiles.save(vm.tabFiles, onSaveSuccess, onSaveError);
            }
        };

        vm.clearPermission = function() {
            if(vm.permissions.permission === "-1"){
                if(vm.permissions.user !== undefined) {
                    vm.permissions.user.permis.r = false;
                    vm.permissions.user.permis.w = false;
                    vm.permissions.user.permis.x = false;
                }
                if(vm.permissions.group !== undefined) {
                    vm.permissions.group.permis.r = false;
                    vm.permissions.group.permis.w = false;
                    vm.permissions.group.permis.x = false;
                }
                if(vm.permissions.other !== undefined) {
                    vm.permissions.other.permis.r = false;
                    vm.permissions.other.permis.w = false;
                    vm.permissions.other.permis.x = false;
                }
            } else {
                vm.permissions.permission = "-1";
                vm.permissions.category = "-1";
            }
        }

        function getPerms() {
            var perms = "";
            if(vm.permissions.user !== undefined) {
                perms += getValuePermsString(vm.permissions.user.permis.r, "r");
                perms += getValuePermsString(vm.permissions.user.permis.w, "w");
                perms += getValuePermsString(vm.permissions.user.permis.x, "x");
            }
            if(vm.permissions.group !== undefined) {
                perms += getValuePermsString(vm.permissions.group.permis.r, "r");
                perms += getValuePermsString(vm.permissions.group.permis.w, "w");
                perms += getValuePermsString(vm.permissions.group.permis.x, "x");
            }
            if(vm.permissions.other !== undefined) {
                perms += getValuePermsString(vm.permissions.other.permis.r, "r");
                perms += getValuePermsString(vm.permissions.other.permis.w, "w");
                perms += getValuePermsString(vm.permissions.other.permis.x, "x");
            }
            return perms;
        }

        function getPermsFromString(perms) {
            if(perms !== undefined && perms !== "---------" && perms !== null) {
                vm.isCustomPermission = true;
                vm.permissions.user = {};
                vm.permissions.group = {};
                vm.permissions.other = {};
                vm.permissions.user.permis = {};
                vm.permissions.group.permis = {};
                vm.permissions.other.permis = {};
                vm.permissions.user.permis.r = perms.charAt(0) !== "-";
                vm.permissions.user.permis.w = perms.charAt(1) !== "-";
                vm.permissions.user.permis.x = perms.charAt(2) !== "-";
                vm.permissions.group.permis.r = perms.charAt(3) !== "-";
                vm.permissions.group.permis.w = perms.charAt(4) !== "-";
                vm.permissions.group.permis.x = perms.charAt(5) !== "-";
                vm.permissions.other.permis.r = perms.charAt(6) !== "-";
                vm.permissions.other.permis.w = perms.charAt(7) !== "-";
                vm.permissions.other.permis.x = perms.charAt(8) !== "-";
            }
        }

        function getValuePermsString(condition, index) {
            if(condition)
                return index;
            return "-";
        }

        vm.clear = function () {
            $state.go('tab-files');
        };

        vm.setFileContent = function ($file, tabFiles) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.fileContentRaw = $window.atob(base64Data);
                        tabFiles.fileContent = base64Data;
                        tabFiles.fileContentType = $file.type;
                    });
                });
            }
        };

        vm.toggleInlineEditor = function () {
            vm.showInlineEditor = !vm.showInlineEditor;
            if (vm.showInlineEditor)
                vm.fileContentRaw = $window.atob(vm.tabFiles.fileContent ? vm.tabFiles.fileContent : "");
        };

        vm.setFileFromEditor = function () {
            vm.tabFiles.fileContent = $window.btoa(vm.fileContentRaw);
        };

        vm.byteSize = DataUtils.byteSize;
    }
})();
